import React, { useEffect, useState } from "react";
import BreadCrumbComponent from "../modules/Breadcrumbs";
import "./queries.scss";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import DropSelect from "../modules/AutoComplete";
import Input from "../modules/Input";
import DocUpload from "../modules/DocUpload";
import BtnSet from "./BtnSet";
import StaticItem from "../modules/StaticItem";
import { GetBaseUrl } from "../modules/getBaseUrl";
import { useSelector, useDispatch } from "react-redux";
import { api } from "../../Services";
import { setCaseId } from "./redux/actions";
import { useNavigate } from 'react-router-dom';

function RaiseQueries() {
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const [query, setQuery] = useState({ cat: "", details: "", doc: [] });
  const [btn, setBtn] = useState(true);
  const tokenData = useSelector((state) => state.tokens.tokens);

  console.log("query", query);
  const viewField = () => {
    let url = GetBaseUrl(window.location.href);
    // window.location.replace(url + "/application/help/view-queries");
    navigate("/application/help/view-queries");

  };
  async function sendQuery() {
    const formData = new FormData();
    let data = {
      salesForceStudentCaseId: null,
      caseCategory: query.cat,
      caseDetails: query.details,
      applicationId: tokenData.appId,
      caseStatus: "Assigned",
      caseDocument: query.doc,
      studentCaseQueries: [],
    };
    // formData.append("salesForceStudentCaseId", null);
    formData.append("caseCategory", query.cat);
    formData.append("caseDetails", query.details);
    formData.append("applicationId", tokenData.appId);
    formData.append("caseStatus", "Assigned");
    formData.append("caseDocument", query.doc);
    formData.append("studentCaseQueries", []);

    console.log("before", data);
    try {
      const send = await api.raiseQuery(data, tokenData.token);
      console.log("query", send);
      dispatch(setCaseId(send.data.caseNumber));
      return send.statusCode == 200 ? send : "failed";
    } catch (error) {
      console.error("Error invoking Aadhaar OTP:", error);
      // Handle error scenario
    }
  }
 
  const showName = (name) => {
    let ext = name.split(".")[name.split(".")?.length - 1];
    name = name.replace(new RegExp("\\b" + ext + "\\b", "ig"), "");
    return (
      <div className="txt-div">
        <div className="txt-div-name">{name}</div>
        {ext}
      </div>
    );
  };

  const setQueryData = (type, e) => {
    let q1 = { ...query };
    q1[type] = e;
    setQuery({
      ...q1,
    });
  };
  useEffect(() => {
    let btn1 = true;
    for (let i in query) {
      if (query[i]?.length === 0) {
        btn1 = false;
      }
    }
    setBtn(btn1);
  }, [query]);
  return (
    <div className=" raise">
      <div className="bc">
        <BreadCrumbComponent list={["Help", "Raise a Query"]} />
      </div>
      <div className="raise-heading">
        <div className="form-title">Raise a Query</div>
        <div onClick={viewField} className="left-btn upload-top-text">
          View Queries
          <NavigateNextIcon fontSize="small" />
        </div>
      </div>
      <div className="cred-fields">
        <DropSelect
          onChange={(e) => setQueryData("cat", e)}
          list={[
            "Aadhar Issue",
            "Login problem Issue",
            "Page Saving issue",
            "Mobile verification OTP issue",
            "Unable to re-edit field values",
            "Website Cache issue",
            "Not able access application",
            "College Not available",
            "City not available",
            "District not Available",
            "Course Not available",
            "Income certificate Query",
            "Family details Query",
            "Documents for upload Query",
            "Scholarship Status",
            "Application status",
            "Extension of Application deadline",
            "Application procedure",
            "Second year application query",
            "Eligibility criteria",
            "Fee Receipt",
            "Name check",
            "Admission letter Query",
            "Fee Receipt Query",
            "Submission Query",
            "Distance/Online Program",
            "Fund Transfer Issue",
            "Phone number changed",            
            "Others",
          ]}
          title={"Choose a category"}
          placeholder={"Search for category"}
        />
        <Input
          onChange={(e) =>
            setQueryData("details", e.replace(/[^a-zA-Z0-9. ]/g, ""))
          }
          placeholder={"Add details here"}
          multiline={true}
        />
       
      </div>
     
      <BtnSet
        onClick={() => sendQuery()}
        isBtn={query.cat === "" || query.details === ""}
        type={"query"}
        btnText={"Submit"}
      />
    </div>
  );
}

export default RaiseQueries;
